import React from 'react';
import { INamedEntityRecognitionLabel } from '@scale/shared/types/params/namedentityrecognition';
import NERLabelMenu from './NERLabelMenu';
import Fuse from 'fuse.js';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { Popover } from '@material-ui/core';
import { makeStyles } from 'design-system/styles';
import classNames from 'classnames';
import _ from 'lodash';
import { IColorMap } from './namedEntityRecognitionLabels';

interface INERAnnotationPreviewProps {
  clientBoxes: {
    top: number;
    left: number;
    width: number;
    height: number;
  }[];
  labels: INamedEntityRecognitionLabel[];
  labelColormap: IColorMap;
  labelSearchIndex: Fuse<INamedEntityRecognitionLabel>;
  onLabelSelect: (label: INamedEntityRecognitionLabel) => void;
  onClickAway: () => void;
}

const NERAnnotationPreview: React.ForwardRefRenderFunction<
  HTMLElement,
  INERAnnotationPreviewProps
> = (
  { clientBoxes, labels, labelColormap, labelSearchIndex, onLabelSelect, onClickAway },
  containerRef: $FIXME,
) => {
  const classes = useNERAnnotationPreviewStyles();

  if (_.isEmpty(clientBoxes)) {
    return null;
  }
  return (
    <>
      {containerRef.current && (
        <Popover
          anchorEl={containerRef.current}
          anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          transformOrigin={{
            horizontal: -clientBoxes[0].left,
            vertical: -_.last(clientBoxes)!.top - 32,
          }}
          open={true}
          onClose={onClickAway}
        >
          <NERLabelMenu
            labels={labels}
            labelColormap={labelColormap}
            onSelect={onLabelSelect}
            onResize={() => {}}
            labelSearchIndex={labelSearchIndex}
          />
        </Popover>
      )}
      {clientBoxes.map(({ top, left, height, width }, idx) => (
        <div
          key={idx}
          className={classNames(classes.tokenContainer, {
            [classes.tokenContainerStart]: idx === 0,
            [classes.tokenContainerEnd]: idx === clientBoxes.length - 1,
          })}
          style={{
            top,
            left,
            height,
            width,
          }}
        />
      ))}
    </>
  );
};

const useNERAnnotationPreviewStyles = makeStyles({
  tokenContainer: {
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.05)',
    borderBottom: `2px solid #404040`,
    userSelect: 'none',
  },
  tokenContainerStart: {
    borderTopLeftRadius: 2,
  },
  tokenContainerEnd: {
    borderTopRightRadius: 2,
  },
});

export default React.forwardRef(NERAnnotationPreview);
